/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1689
 */

var r = require(/* 194 */"../1648/194")
module.exports = function (e, t) {
  var /* [auto-meaningful-name] */r$console = r.console
  if (r$console && r$console.error) {
    if (1 === arguments.length) {
      r$console.error(e)
    } else {
      r$console.error(e, t)
    }
  }
}
